<template>
  <a @click.prevent="getMessageDetails" class="p-j-message-article-panel">
    <div class="p-j-message-article-panel__body">
      <div class="p-j-message-article-panel__icon">
        <IconUserImage :size="40">
          <img :src="icon" alt />
        </IconUserImage>
      </div>

      <JMessageArticlePanelBody
        :detail-data="detailData"
        :unread-count-is-exists="unreadCountIsExists"
      />

      <div v-if="pointIsExists" class="p-j-message-article-panel__point">
        <ThanksMessagePointSummary
          :gift-points="point.giftPoints"
          :received-points="point.receivedPoints"
          :date="messageArticleDetail.date"
          :unread-count="messageArticleDetail.unread_count"
        />
      </div>
    </div>
  </a>
</template>

<script lang="ts">
import TextLabel from "@/common/components/atoms/TextLabel.vue";
import ThanksMessagePointSummary from "@/common/components/atoms/ThanksMessagePointSummary.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";

import JMessageArticlePanelBody from "@/general/components/pages/parts/ThanksPointList/JMessageArticlePanelBody.vue";
import { Options, Vue } from 'vue-class-component';
import commons from "@/common/store/modules/commons";
import auth from "@/general/store/modules/auth";
@Options({
  name: "JMessageArticlePanel",
  props: {
	messageArticleDetail: { type: Object, required: true },
	exclude: { type: Array, required: true }
  },
  components: {
    TextLabel,
    ThanksMessagePointSummary,
    SmallText,
    IconUserImage,
    JMessageArticlePanelBody
  }
})
export default class JMessageArticlePanel extends Vue {
  messageArticleDetail!: Record<
    string,
    any
  >;
  exclude!: any;

  textLabel = {
    send: {
      text: "送付",
      style: {
        border: "#ffffff",
        content: commons.colorCode
      }
    },
    receive: {
      text: "受取",
      style: {
        border: commons.colorCode,
        content: "#ffffff"
      }
    },
    customStyle: {
      width: "100%",
      minWidth: "100%"
    }
  };
  get date() {
    const getDate = new Date(this.messageArticleDetail.date);
    const UTCDate = getDate.toUTCString();
    const timeStamp = Date.parse(UTCDate);
    const ConvertDate = new Date(timeStamp);
    // const parsedDate = ConvertDate.toLocaleDateString();
    const parsedDate =
      ConvertDate.getFullYear() +
      "/" +
      ("0" + (ConvertDate.getMonth() + 1)).slice(-2) +
      "/" +
      ConvertDate.getDate();
    return parsedDate;
  }

  get url() {
    return this.messageArticleDetail.url;
  }

  get icon() {
    return this.messageArticleDetail.icon.medium;
  }

  get name() {
    return this.messageArticleDetail.name;
  }

  get content() {
    return this.messageArticleDetail.content;
  }

  get point() {
    return this.messageArticleDetail.point;
  }

  get sign() {
    return this.messageArticleDetail.point.state == "sent" ? false : true;
  }

  get textLabelObj() {
    const state = this.messageArticleDetail.point.state;
    if (state === "sent") {
      return this.textLabel.send;
    } else if (state === "received") {
      return this.textLabel.receive;
    } else {
      return this.textLabel.customStyle;
    }
  }

  get unread() {
      return this.messageArticleDetail.unread;
  }
  
  get unreadTotalCount() {
      const total = this.messageArticleDetail.unread_count;
      return total >= 10 ? "..." : total;
  }
  get UnreadCountisExist() {
	  return this.messageArticleDetail.unread_count	> 0 ? true : false;
  }

  get detailData() {
    const {
      content,
      date,
      icon,
      id,
      user_id,
      name,
      point,
      url,
      unreadCount,
      groupName,
      groupCode,
      isDeleted
    } = this.messageArticleDetail;

    return {
      content,
      date,
      icon,
      id,
      user_id,
      name,
      point,
      url,
      unreadCount,
      groupName,
      groupCode,
      isDeleted
    };
  }

  get headerIsExists() {
    const exclude = this.exclude;
    const isExclude = exclude.includes("header");
    return !isExclude;
  }

  get unreadCountIsExists() {
    const exclude = this.exclude;
    const isExclude = exclude.includes("unreadCount");
    return !isExclude;
  }

  get pointIsExists() {
    const exclude = this.exclude;
    const isExclude = exclude.includes("point");
    return !isExclude;
  }

  getMessageDetails() {
    localStorage.setItem(
      "messageCardDetails",
      JSON.stringify(this.messageArticleDetail)
    );
    window.location.href = this.url;
  }

  get messsageThreadEnabled() {
    return auth.user.thread_enabled;
  }
}
</script>

<style lang="scss" scoped>
.p-j-message-article-panel {
  color: inherit;
  text-decoration: none;
  width: 100%;
  display: block;
  padding: rem(8) rem(16);

  &__header {
    display: flex;
    align-items: center;
  }

  &__state {
    width: rem(38);
    min-width: rem(38);
  }

  &__date {
    margin-left: rem(8);
    display: block;
  }

  &__body {
    @include pc {
      margin-top: rem(8);
      display: flex;
    }
    @include sp {
      display: flex;
      flex-wrap: wrap;
    }
  }

  &__icon {
    width: rem(40);
    min-width: rem(40);
    margin-right: rem(8);
    display: block;
  }

  &__point {
    @include pc {
      min-width: rem(190);
      display: flex;
      justify-content: flex-end;
    }

    @include sp {
      width: calc(100% - 48px);
      margin-top: rem(8);
      margin-left: rem(48);
    }
  }
}
.p-j-message-article-panel:hover {
  color: inherit;
}
</style>
